var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[_vm._v(" 1231231 ")])}
var staticRenderFns = []

export { render, staticRenderFns }